import React from 'react';
import './HeaderMain.css';

const HeaderMain = () => {
    return (
        
         <div className="header-container">
            <div className="header-main">
            <div className="p-5">
            <h5 className="text-brand">outstading</h5>
            <h1 style={{color:"white"}}>Nanny and Babby Sitting <br></br> services </h1>
            <button className="btn btn-brand">Book Sitter</button>
            </div>
            </div>
        </div>
    );
};

export default HeaderMain;